import { render, staticRenderFns } from "./CreateTeam.vue?vue&type=template&id=09cc681a&"
import script from "./CreateTeam.vue?vue&type=script&lang=ts&"
export * from "./CreateTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports